// stores
import * as ContractStore from '../../../../../redux/middleware/ContractMiddleware';

// state
import { AppState } from '../../../../../redux/reducers';
import { Protocol } from '../../../../../models/Entities/Protocols/Protocol';
import { Contract } from '../../../../../models/Entities/Contracts/Contract';

//#region Props

interface IProps {
    ProtocolId: number;
}

interface ConnectedProps {
    /** Undefined while the protocol or its association has not loaded yet. */
    ContractId: number | undefined;
    Contract: Contract | undefined;
    isLoadingContract: boolean;
}

interface DispatchProps {
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const CurrentProtocol: Protocol | undefined =
        state.MedicalProtocols?.list?.find((protocol: Protocol) => protocol.id === ownProps.ProtocolId) || undefined;

    const ContractId = CurrentProtocol?.contractAssociation?.contractId;

    const CurrentContract: Contract | undefined = ContractId
        ? state.Contract?.list?.find((contract: Contract) => contract.id === ContractId)
        : undefined;

    return {
        ContractId: ContractId,
        Contract: CurrentContract,
        isLoadingContract: state.Contract?.isLoadingOne || false,
    };
};

export const mapDispatchToProps = {
    ...ContractStore.actionCreators
};

//#endregion Props
